<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },

  region: {
    type: String,
    required: true,
  },

  size: {
    type: String,
    default: 'sm',
    validator(value) {
      return ['sm', 'md', 'xl'].includes(value);
    },
  },

  hasMore: {
    type: Boolean,
    default: false,
  },
});

const { tp } = useTypograf();
</script>

<template>
  <div class="card-market" :class="`card-market--size--${size}`">
    <div class="card-market__head">
      <h3 class="card-market__title">
        <span class="card-market__font card-market__font--title">
          {{ title }}
        </span>
      </h3>

      <div class="card-market__subtitle">
        <span class="card-market__font card-market__font--subtitle">
          {{ $t('markets.commissionPerMonth') }}
        </span>
      </div>
    </div>

    <div class="card-market__region">
      <span class="card-market__font card-market__font--region">
        {{ tp(region) }}
      </span>

      <span v-if="hasMore" class="card-market__font card-market__font--more">
        {{ $t('markets.more') }}
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card-market {
  background-color: $color-white;
  padding-block: em(46) em(33);
  padding-inline: em(59) em(59);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @include media-breakpoint-desktop {
    border-bottom: 1px solid $color-main-1;
  }

  @include media-breakpoint-mobile {
    border-inline-start: 1px solid $color-main-1;
    padding-block: em(15) em(17);
    padding-inline: em(17) em(11);
  }

  &__head {
    margin-bottom: em(109);

    @include media-breakpoint-desktop {
      margin-inline-end: em(-10);
    }

    @include media-breakpoint-mobile {
      margin-bottom: em(9);
    }
  }

  &__font {
    &--title {
      font-weight: $font-weight-semi-bold;
      font-size: em(80);
      line-height: 1;

      @include media-breakpoint-mobile {
        font-size: em(24);
      }
    }

    &--subtitle {
      font-size: em(20);

      @include media-breakpoint-mobile {
        font-size: em(14);
      }
    }

    &--region {
      font-size: em(48);

      @include media-breakpoint-mobile {
        font-size: em(18);
        font-weight: $font-weight-semi-bold;
      }
    }

    &--more {
      font-size: em(20);
      white-space: nowrap;

      @include media-breakpoint-mobile {
        font-size: em(14);
      }
    }
  }

  &__region {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    @include media-breakpoint-mobile {
      flex-direction: column;
      align-items: flex-start;
      gap: em(2);
    }
  }

  &--size {
    &--sm {
      @include media-breakpoint-mobile {
        width: em(181);
      }
    }
    &--md {
      @include media-breakpoint-mobile {
        width: em(260);
      }

      @include media-breakpoint-desktop {
        min-height: em(469);
      }
    }
    &--xl {
      @include media-breakpoint-mobile {
        width: 100%;
      }

      @include media-breakpoint-desktop {
        min-height: em(807);
      }
    }
  }
}
</style>
